import { SettingTaxGroup } from './../../models/setting-tax-group.entity';
import http, { HttpSuccessOrErrorType } from '../http';

export default {
    /**
     * 根据餐厅string_id获取税率组列表
     * @param string_id 餐厅string_id
     */
    async get_tax_group(string_id: string): Promise<HttpSuccessOrErrorType<SettingTaxGroup[]>> {
        return await http.get(`/restaurant/${string_id}/tax_group`)
    }
}